import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

fetch('/assets/config.json')
  .then(res => {
    if (!res.ok) throw new Error(`config request failed: ${res.status}`);
    return res.json();
  })
  .then(config => {
    console.log('Loaded runtime config:', config);
    Object.assign(environment, config);
    console.log('environment after merge:', environment);
  })
  .catch(err => console.error('Config load failed:', err))
  .finally(() => {
    platformBrowserDynamic().bootstrapModule(AppModule);
  });
